import React from "react";
import "../../styles/PrivacyStatement.css"; // Import global styling
import { Link } from "react-router-dom";

function PrivacyStatement() {
  return (
    <div className="page-container">
      <div className="content-wrap">
        <div className="privacy-container">
          <h1>Privacy Statement</h1>
          <p>
            Welcome to PuyVast is committed to protecting your privacy and developing
            technology that gives you the most powerful and safe online experience.
            This Statement of Privacy applies to the Welcome to PuyVast Web site and
            governs data collection and usage. By using the Welcome to PuyVast website,
            you consent to the data practices described in this statement.
          </p>

          <h2>Collection of your Personal Information</h2>
          <p>
            Welcome to PuyVast collects personally identifiable information, such as
            your e-mail address, name, home or work address or telephone number. Welcome
            to PuyVast also collects anonymous demographic information, which is not
            unique to you, such as your ZIP code, age, gender, preferences, interests,
            and favorites.
          </p>

          <h2>Use of your Personal Information</h2>
          <p>
            Welcome to PuyVast collects and uses your personal information to operate
            the Welcome to PuyVast Web site and deliver the services you have requested.
            Welcome to PuyVast also uses your personally identifiable information to
            inform you of other products or services available from Welcome to PuyVast
            and its affiliates.
          </p>

          <h2>Use of Cookies</h2>
          <p>
            The Welcome to PuyVast Web site uses "cookies" to help you personalize your
            online experience. A cookie is a text file that is placed on your hard disk
            by a Web page server. Cookies cannot be used to run programs or deliver
            viruses to your computer.
          </p>

          <h2>Security of your Personal Information</h2>
          <p>
            Welcome to PuyVast secures your personal information from unauthorized access,
            use, or disclosure. Welcome to PuyVast secures the personally identifiable
            information you provide on computer servers in a controlled, secure
            environment.
          </p>

          <h2>Changes to this Statement</h2>
          <p>
            Welcome to PuyVast will occasionally update this Statement of Privacy to
            reflect company and customer feedback. Welcome to PuyVast encourages you
            to periodically review this Statement.
          </p>

          <h2>Contact Information</h2>
          <p>
            Welcome to PuyVast welcomes your comments regarding this Statement of
            Privacy. If you believe that Welcome to PuyVast has not adhered to this
            Statement, please contact Welcome to PuyVast at
            <a href="mailto:sudhir@codeswork.com" className="email-link"> sudhir@codeswork.com</a>.
          </p>
        </div>
      </div>

      {/* Footer */}
      <footer className="footer">
        <div className="footer-container">
          {/* Left Section - CIN & Links */}
          <div className="footer-left">
            <p>CIN Number: U63030KA2022PTC161825</p>
            <p>
              <Link to="/privacy-statement" className="footer-link">Privacy Statement</Link> |
              <Link to="/terms-of-use" className="footer-link"> Terms Of Use</Link>
            </p>
          </div>

          {/* Center - Copyright */}
          <div className="footer-center">
            <p>© {new Date().getFullYear()} ONEVEGA Systems (India) Pvt Ltd.</p>
          </div>

          {/* Right Section - Registered Office */}
          <div className="footer-right">
            <p><strong>Registered Office</strong></p>
            <p>Puyvast Logistics Pvt. Ltd.</p>
            <p>PuyVast House </p>
            <p>4th Floor ,#6, Harris Road, Benson Town,<br></br> Bangalore - 560 046.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default PrivacyStatement;
